import { useTranslation } from 'react-i18next';
import { Target, CheckCircle, AlertTriangle } from 'lucide-react';
import { getScoreColor } from '../helpers';
import MiniKpiBar from '../shared/MiniKpiBar';

export default function MockupReport() {
  const { t } = useTranslation();

  const categories = [
    { name: t('landing.mockupApertura'), score: 85, kpis: [{ label: t('landing.mockupSaludo'), score: 88 }, { label: t('landing.mockupContexto'), score: 82 }] },
    { name: t('landing.mockupEscucha'), score: 78, kpis: [{ label: t('landing.mockupPreguntas'), score: 80 }, { label: t('landing.mockupParafraseo'), score: 75 }] },
    { name: t('landing.mockupPropuesta'), score: 90, kpis: [{ label: t('landing.mockupValor'), score: 92 }, { label: t('landing.mockupAdaptacion'), score: 88 }] },
    { name: t('landing.mockupObjeciones'), score: 72, kpis: [{ label: t('landing.mockupRebatir'), score: 70 }, { label: t('landing.mockupEmpatia'), score: 74 }] },
    { name: t('landing.mockupCierre'), score: 88, kpis: [{ label: t('landing.mockupPropuestaKpi'), score: 90 }, { label: t('landing.mockupUrgencia'), score: 85 }] },
    { name: t('landing.mockupRapport'), score: 80, kpis: [{ label: t('landing.mockupTono'), score: 83 }, { label: t('landing.mockupConexion'), score: 77 }] },
  ];

  return (
    <div className="rounded-xl border border-border bg-card p-4 shadow-sm">
      <div className="mb-3 flex items-center justify-between">
        <div>
          <p className="text-xs font-heading text-foreground">{t('landing.mockupReportTitle')}</p>
          <p className="text-[9px] text-muted-foreground">
            {t('landing.mockupSessionWith')} <span className="font-semibold text-primary">Mentor IA</span> — 12 min
          </p>
        </div>
        <div className="flex flex-col items-center rounded-xl border border-border bg-card p-2.5">
          <p className="text-[7px] font-medium uppercase tracking-wider text-muted-foreground">{t('landing.mockupScoreLabel')}</p>
          <p className="text-2xl font-extrabold" style={{ color: getScoreColor(82) }}>82</p>
          <p className="text-[8px] text-muted-foreground">/99</p>
        </div>
      </div>

      <div className="mb-3 rounded-lg border border-border bg-card p-2">
        <div className="flex items-start gap-1.5">
          <Target className="mt-0.5 h-3 w-3 shrink-0 text-primary" />
          <div>
            <p className="text-[9px] font-semibold text-foreground">{t('landing.mockupSummary')}</p>
            <p className="text-[8px] leading-relaxed text-muted-foreground">
              {t('landing.mockupSummaryText')}
            </p>
          </div>
        </div>
      </div>

      <div className="mb-3 grid grid-cols-2 gap-1.5 sm:grid-cols-3">
        {categories.map((cat) => (
          <div key={cat.name} className="rounded-lg border border-border bg-card p-2">
            <div className="mb-1.5 flex items-center justify-between">
              <div className="flex items-center gap-1">
                <div className="h-1.5 w-1.5 rounded-full" style={{ backgroundColor: getScoreColor(cat.score) }} />
                <span className="text-[8px] font-semibold text-foreground">{cat.name}</span>
              </div>
              <span className="text-[10px] font-extrabold" style={{ color: getScoreColor(cat.score) }}>
                {cat.score}
              </span>
            </div>
            <div className="space-y-1">
              {cat.kpis.map((k) => (
                <MiniKpiBar key={k.label} label={k.label} score={k.score} variant="stacked" />
              ))}
            </div>
          </div>
        ))}
      </div>

      <div className="grid grid-cols-2 gap-1.5">
        <div className="rounded-lg border border-border bg-card p-2">
          <p className="mb-1 text-[9px] font-semibold text-foreground">{t('landing.mockupStrengths')}</p>
          <div className="space-y-1">
            {[t('landing.mockupStrength1'), t('landing.mockupStrength2')].map((s) => (
              <div key={s} className="flex items-start gap-1">
                <CheckCircle className="mt-0.5 h-2.5 w-2.5 shrink-0 text-green-500" />
                <span className="text-[8px] text-muted-foreground">{s}</span>
              </div>
            ))}
          </div>
        </div>
        <div className="rounded-lg border border-border bg-card p-2">
          <p className="mb-1 text-[9px] font-semibold text-foreground">{t('landing.mockupImprovements')}</p>
          <div className="space-y-1">
            {[t('landing.mockupImprovement1'), t('landing.mockupImprovement2')].map((s) => (
              <div key={s} className="flex items-start gap-1">
                <AlertTriangle className="mt-0.5 h-2.5 w-2.5 shrink-0 text-orange-500" />
                <span className="text-[8px] text-muted-foreground">{s}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
